module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-regular.9c6a1ff2.woff2";